export const applicationLinksContext = require.context(
  ".",
  true,
  /\_controller.js$/
);
